// extracted by mini-css-extract-plugin
export var aircallIframe = "_mn-3";
export var fabContainer = "_mn-5";
export var fabRinging = "_mn-6";
export var loadingOverlay = "_mn-4";
export var pulse = "_mn-7";
export var widgetContent = "_mn-2";
export var widgetPanel = "_mn-0";
export var widgetPanelExpanded = "_mn-1";